import { gql } from '@apollo/client';

export const GET_ORDERS_BY_SORTING_CODE = gql`
  query GetOrdersBySortingCode(
    $filters: OrdersBySortingCodeFiltersTypeInput!
    $pageRequest: PageRequestTypeInput
  ) {
    getOrdersBySortingCode(
      filters: $filters
      pageRequest: $pageRequest
    ) {
      data {
        id
        trackingNumber
        overallStatus
      }
      pagination {
        page
        size
        total
        totalPages
      }
    }
  }
`;

export interface OrderListItem {
  id: string;
  trackingNumber: string;
  overallStatus?: string;
}

export interface OrderListPagination {
  page: number;
  size: number;
  total: number;
  totalPages: number;
}

export interface GetOrdersBySortingCodeResponse {
  getOrdersBySortingCode: {
    data: OrderListItem[];
    pagination: OrderListPagination;
  };
}
